module.exports = __webpack_public_path__ + "static/bg-light-mob-c0c7373f274a4ce90497bd7ef047d7b8.png";